import React, { useState } from 'react';

import { clsx } from 'clsx';

import { Icon, Text } from 'components';
import { TEXT_SIZES } from 'components/Text/constants';

import * as styles from './styles.module.scss';

function QuestionAccordion({ question, answer }) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className={styles.card}>
      <button
        className={clsx(styles.button, {
          [styles.button___open]: isOpen,
        })}
        onClick={() => setIsOpen(!isOpen)}
      >
        <Text className={styles.button_text} size={TEXT_SIZES.LG}>
          {question}
        </Text>
        <Icon className={styles.button_icon} name="expand_more" />
      </button>
      {isOpen && (
        <div className={styles.answer}>
          <Text>{answer}</Text>
        </div>
      )}
    </div>
  );
}

export default QuestionAccordion;
